import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { StorageManager } from "@/features/admin/components/storage-manager";
import { PageContainer } from "@fleet/ui";

function AdminStoragePage() {
  return (
    <PageContainer maxWidth="5xl">
      <StorageManager />
    </PageContainer>
  );
}

interface AdminStorageSearch {
  filter?: "orphaned" | "linked";
}

export const adminStorageRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/storage",
  validateSearch: (raw: Record<string, unknown>): AdminStorageSearch => ({
    filter: raw.filter === "orphaned" || raw.filter === "linked" ? raw.filter : undefined,
  }),
  component: AdminStoragePage,
});
